// theme.js
export const blueTheme = {
  body: "#EDF9FE",
  text: "#001C55",
  expTxtColor: "#000a12",
  highlight: "#A6E1FA",
  dark: "#00072D",
  secondaryText: "#7F8DAA",
  imageHighlight: "#0E6BA8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#0A2472",
  headerColor: "#0E6BA877",
  splashBg: "#001C55",
};

export const brownTheme = {
  body: "#FFFEFD",
  text: "#5D2A42",
  expTxtColor: "#000a12",
  highlight: "#FFF9EC",
  dark: "#00072D",
  secondaryText: "#8D697A",
  imageHighlight: "#E29F95",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#FB6376",
  headerColor: "#E29F9577",
  splashBg: "#5D2A42",
};

export const purpleTheme = {
  body: "#F8EFF4",
  text: "#231942",
  expTxtColor: "#000a12",
  highlight: "#E0B1CB",
  dark: "#00072D",
  secondaryText: "#655E7A",
  imageHighlight: "#BE95C4",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#5E548E",
  headerColor: "#BE95C477",
  splashBg: "#231942",
};

export const greenTheme = {
  body: "#FFFFEB",
  text: "#003F2F",
  expTxtColor: "#000a12",
  highlight: "#dddf00",
  dark: "#00072D",
  secondaryText: "#4CA58F",
  imageHighlight: "#55a630",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#007f5f",
  headerColor: "#55a63077",
  splashBg: "#003F2F",
};

export const redTheme = {
  body: "#FFF8E6",
  text: "#6a040f",
  expTxtColor: "#000a12",
  highlight: "#ffba08",
  dark: "#03071e",
  secondaryText: "#964F56",
  imageHighlight: "#dc2f02",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#9d0208",
  headerColor: "#dc2f0277",
  splashBg: "#6a040f",
};

export const blackTheme = {
  body: "#E5E5E5",
  text: "#14213d",
  expTxtColor: "#000a12",
  highlight: "#ffffff",
  dark: "#000000",
  secondaryText: "#5A6377",
  imageHighlight: "#fca311",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8d99ae",
  headerColor: "#fca31177",
  splashBg: "#14213d",
};

export const pinkTheme = {
  body: "#FEE9F2",
  text: "#620E34",
  expTxtColor: "#000a12",
  highlight: "#FBA7CD",
  dark: "#31071A",
  secondaryText: "#ef476f",
  imageHighlight: "#ef476f",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8d99ae",
  headerColor: "#ef476f77",
  splashBg: "#620E34",
};

export const violetTheme = {
  body: "#F4EEFC",
  text: "#430A58",
  expTxtColor: "#000a12",
  highlight: "#D6BEF4",
  dark: "#21052C",
  secondaryText: "#875599",
  imageHighlight: "#9b5de5",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#763D8B",
  headerColor: "#9b5de577",
  splashBg: "#430A58",
};

export const tealTheme = {
  body: "#E6FAF5",
  text: "#084c61",
  expTxtColor: "#000a12",
  highlight: "#9BEED8",
  dark: "#031E26",
  secondaryText: "#528190",
  imageHighlight: "#07beb8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#56a3a6",
  headerColor: "#07beb877",
  splashBg: "#084c61",
};

export const orangeTheme = {
  body: "#FFF0EA",
  text: "#99401F",
  expTxtColor: "#000a12",
  highlight: "#FFB59A",
  dark: "#33150A",
  secondaryText: "#CC552A",
  imageHighlight: "#FF6B35",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#d7263d",
  headerColor: "#FF6B3577",
  splashBg: "#99401F",
};

export const yellowTheme = {
  body: "#FFD95D",
  text: "#5f4339",
  expTxtColor: "#000a12",
  highlight: "#ffff73",
  dark: "#8d6e63",
  secondaryText: "#5f4339",
  imageHighlight: "#ffea3d",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#4e342e",
  headerColor: "#FFEA3D",
  splashBg: "#5f4339",
};

export const materialDarkTheme = {
  body: "#263238",
  text: "#aeaeae",
  expTxtColor: "#000a12",
  highlight: "#4f5b62",
  dark: "#000a12",
  secondaryText: "#aeaeae",
  imageHighlight: "#607d8b",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8eacbb",
  headerColor: "#34515e",
  splashBg: "#4f5b62",
};

export const materialLightTheme = {
  body: "#ffffff",
  text: "#4c2b91",
  expTxtColor: "#000000",
  highlight: "#E9E3F5",
  dark: "#1d0c41",
  secondaryText: "#7d56c2",
  imageHighlight: "#2b1958",
  compImgHighlight: "#E1E2E1",
  jacketColor: "#E1E2E1",
  headerColor: "#E1E2E1",
  splashBg: "#7d56c2",
};

export const materialTealTheme = {
  body: "#ffffff",
  text: "#05505E",
  expTxtColor: "#000000",
  highlight: "#a1dded",
  dark: "#07292c",
  secondaryText: "#05505E",
  imageHighlight: "#0a343c",
  compImgHighlight: "#E1E2E1",
  jacketColor: "#E1E2E1",
  headerColor: "#E1E2E1",
  splashBg: "#05505E",
};

export const oceanDreamTheme = {
  body: "#EAF6FF",
  text: "#0A3359",
  expTxtColor: "#00101A",
  highlight: "#6FD9FF",
  dark: "#001529",
  secondaryText: "#607D99",
  imageHighlight: "#147ABE",
  compImgHighlight: "#E5E5E5",
  jacketColor: "#0E4D7B",
  headerColor: "#147ABE77",
  splashBg: "#0A3359",
};

export const sunsetSerenityTheme = {
  body: "#FFF3E6",
  text: "#4D2600",
  expTxtColor: "#1A0F00",
  highlight: "#FFD9B3",
  dark: "#331A00",
  secondaryText: "#996D4D",
  imageHighlight: "#FF8533",
  compImgHighlight: "#F2F2F2",
  jacketColor: "#663300",
  headerColor: "#FF853377",
  splashBg: "#4D2600",
};

export const mysticForestTheme = {
  body: "#E6F2E6",
  text: "#003311",
  expTxtColor: "#001A0D",
  highlight: "#9EDB9E",
  dark: "#00220D",
  secondaryText: "#668066",
  imageHighlight: "#1AA366",
  compImgHighlight: "#E0E0E0",
  jacketColor: "#004D26",
  headerColor: "#1AA36677",
  splashBg: "#003311",
};

export const midnightAura = {
  body: "#121212",
  text: "#FFFFFF",
  expTxtColor: "#CCCCCC",
  highlight: "#1E88E5",
  dark: "#000000",
  secondaryText: "#757575",
  imageHighlight: "#64B5F6",
  compImgHighlight: "#424242",
  jacketColor: "#0D47A1",
  headerColor: "#1976D277",
  splashBg: "#0D47A1",
};

export const cosmicTwilight = {
  body: "#0D0D0D",
  text: "#CCCCCC",
  expTxtColor: "#999999",
  highlight: "#FF4081",
  dark: "#000000",
  secondaryText: "#757575",
  imageHighlight: "#F06292",
  compImgHighlight: "#424242",
  jacketColor: "#311B92",
  headerColor: "#E91E6377",
  splashBg: "#311B92",
};

export const shadowedForest = {
  body: "#1B1B1B",
  text: "#E0E0E0",
  expTxtColor: "#CCCCCC",
  highlight: "#4CAF50",
  dark: "#000000",
  secondaryText: "#9E9E9E",
  imageHighlight: "#66BB6A",
  compImgHighlight: "#424242",
  jacketColor: "#1B5E20",
  headerColor: "#388E3C77",
  splashBg: "#1B5E20",
};

export const lightishRedTheme = {
  body: "#F9EBEA",
  text: "#8E44AD",
  expTxtColor: "#6C3483",
  highlight: "#F1948A",
  dark: "#641E16",
  secondaryText: "#A93226",
  imageHighlight: "#D98880",
  compImgHighlight: "#E6B0AA",
  jacketColor: "#922B21",
  headerColor: "#E74C3C77",
  splashBg: "#8E44AD",
};
export const blackAndRedTheme = {
  body: "#000000",
  text: "#FF0000",
  expTxtColor: "#990000",
  highlight: "#FF5733",
  dark: "#330000",
  secondaryText: "#CCCCCC",
  imageHighlight: "#FF6666",
  compImgHighlight: "#666666",
  jacketColor: "#660000",
  headerColor: "#FF573377",
  splashBg: "#FF0000",
};

export const lightReddishTheme = {
  body: "#FFE6E6",
  text: "#660000",
  expTxtColor: "#4D0000",
  highlight: "#FF9999",
  dark: "#330000",
  secondaryText: "#994D4D",
  imageHighlight: "#FF6666",
  compImgHighlight: "#FFCCCC",
  jacketColor: "#CC3333",
  headerColor: "#FF666677",
  splashBg: "#660000",
};

export const allThemes = {
  blueTheme,
  brownTheme,
  purpleTheme,
  greenTheme,
  redTheme,
  blackTheme,
  pinkTheme,
  violetTheme,
  tealTheme,
  orangeTheme,
  yellowTheme,
  materialDarkTheme,
  materialLightTheme,
  materialTealTheme,
  oceanDreamTheme,
  sunsetSerenityTheme,
  mysticForestTheme,
  midnightAura,
  cosmicTwilight,
  shadowedForest,
  lightishRedTheme,
  blackAndRedTheme,
  lightReddishTheme,
};

export const chosenTheme = lightReddishTheme;
